import { useState, useMemo, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useStateValue } from "../../context/StateProvider";

import AddNewDeal from "../home/add-deal";
import ImportantDatesWidget from "../home/ImportantDatesWidget";
import { deleteObject, ref } from "firebase/storage";
import {
  getTaskTemplate,
  updateItem,
  uploadImagesToFirebase,
} from "../../utils/firebasefunctions";
import { toast } from "react-toastify";
import StatusFilter from "./statusFilter";
import TransactionFilter from "./transactionType";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import LeadSourcePopup from "./leadSourceFilter";
import AgentPopUp from "./agentFilter";
import { doc, getDoc } from "firebase/firestore";
import { firestored, storage } from "../../firebase/firebaseConfig";
import {
  FunnelX,
  FileText,
  Clock,
  CheckCircle2,
  TrendingUp,
  Wallet,
  Coins,
  Hourglass,
  PiggyBank,
} from "lucide-react";
import DealCard from "./deal-card";
import { formatCurrency, formatNumberShort, newmessagesuccess, notifyAccountantsOnApproval } from "../../utils/helper";
import { actionType } from "../../context/reducer";
import BulkUploadDeals from "./BulkUploadDeals";
import StatDetails from "./StatDetails";
import DeleteDeal from "./delete-deal";
import { getAlldealforAdmin } from "./../../utils/firebasefunctions";
import CapTypePopUp from "../CapTypePopUp";

export default function TransactionTab(props) {
  const [{ users, user, steps, leadsource, employees }, dispatch] =
    useStateValue();

  // URL-backed filter state. Means hitting "back" from a deal detail
  // restores whatever search/filter you had — no resetting to defaults.
  const [searchParams, setSearchParams] = useSearchParams();

  const [isOpen, setIsOpen] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [editdata, seteditdata] = useState({});
  const [startingdate, setstartingdate] = useState(
    new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0),
  );
  const [endingdate, setendingdate] = useState(
    new Date(new Date().getFullYear(), 11, 31, 23, 59, 59, 999),
    // new Date(new Date().setHours(23, 59, 59, 59)),
  );
  const [search, setSearch] = useState(searchParams.get("q") || "");
  const [statusPopup, setStatusPopup] = useState(false);
  const [teamleadpopup, setteamleadpopup] = useState(false);
    const [captypepopup, setcaptypepopup] = useState(false);
  const [transactionpopup, settransactionpopup] = useState(false);
  const [leadpopup, setleadpopup] = useState(false);
  const [agentpopup, setagentpopup] = useState(false);
  const [statspopup, setstatspopup] = useState(false);
  const [statsdata, setstatsdata] = useState([]);
  const [tasks, setTasks] = useState({});

  const [selectedstat, setselectedstat] = useState("");
  // Filters seed from URL params (?status=...&capType=...&type=...&lead=...&agent=...)
  const [selectedStatus, setSelectedStatus] = useState(
    searchParams.get("status") || "All Status",
  );
    const [captype, setcaptype] = useState(searchParams.get("capType") || "All");
  const [selectedTransaction, setSelectedTransaction] = useState(
    searchParams.get("type") || "All Types",
  );
  const [selectedLead, setSelectedLead] = useState(
    searchParams.get("lead") || "All Leads",
  );
  const [selectedagent, setSelectedagent] = useState(
    searchParams.get("agent") || "All Agents",
  );
  // agentname is the display label; selectedagent is the underlying user id.
  // On first render `users` may not be loaded yet — start with the sentinel
  // and a useEffect below resolves the real display name once `users` arrives.
  const [agentname, setagentname] = useState("All Agents");

  // Resolve the agent display name from the URL-stored id once users load.
  useEffect(() => {
    if (!selectedagent || selectedagent === "All Agents") {
      setagentname("All Agents");
      return;
    }
    const u = (users || []).find((x) => x.id === selectedagent);
    if (u) {
      setagentname(
        `${u.firstname || ""} ${u.lastname || ""}`.trim() || "All Agents",
      );
    }
  }, [selectedagent, users]);

  const [creationDate, setCreationDate] = useState(
    searchParams.get("from") ? new Date(searchParams.get("from")) : null,
  );
  const [closingDate, setClosingDate] = useState(
    searchParams.get("to") ? new Date(searchParams.get("to")) : null,
  );
  // Quick Filters
  const allFilters = ["All", "My Deals", "Closing Soon", "New This Week"];
  const filters =
    user.role === "Admin" || user.role === "Supervisor"
      ? allFilters
      : user.role == "Accountant"
        ? ["All", "Closing Soon", "New This Week"]
        : ["My Deals", "Closing Soon", "New This Week"];

  const defaultActiveFilter =
    user.role === "Admin" ||
    user.role === "Supervisor" ||
    user.role == "Accountant"
      ? "All"
      : "My Deals";
  const [activeFilter, setActiveFilter] = useState(
    searchParams.get("quick") || defaultActiveFilter,
  );

  // Keep the URL in sync whenever any filter or search changes. Non-default
  // values land as query params; defaults get dropped so the URL stays
  // clean. We use replace:true so each keystroke doesn't litter browser
  // history — only the latest state is in the URL.
  useEffect(() => {
    const next = new URLSearchParams();
    if (search) next.set("q", search);
    if (selectedStatus && selectedStatus !== "All Status")
      next.set("status", selectedStatus);
    if (captype && captype !== "All") next.set("capType", captype);
    if (selectedTransaction && selectedTransaction !== "All Types")
      next.set("type", selectedTransaction);
    if (selectedLead && selectedLead !== "All Leads")
      next.set("lead", selectedLead);
    if (selectedagent && selectedagent !== "All Agents")
      next.set("agent", selectedagent);
    if (creationDate) next.set("from", creationDate.toISOString().slice(0, 10));
    if (closingDate) next.set("to", closingDate.toISOString().slice(0, 10));
    if (activeFilter && activeFilter !== defaultActiveFilter)
      next.set("quick", activeFilter);
    setSearchParams(next, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    search,
    selectedStatus,
    captype,
    selectedTransaction,
    selectedLead,
    selectedagent,
    creationDate,
    closingDate,
    activeFilter,
  ]);


  const columnIds = [
    "Prospect",
    "On Hold",
    "CMAs",
    "Listing Appointment",
    "Pre-Market",
    "Coming Soon",
    "Active",
    "Under Contract",
    "Pending",
    "Closed",
    "Cancelled",
    "Expired",
  ];

  const updatedeal = async (data, bool, id) => {
    let finalImageUrls = [];
    const incomingFiles = data.step1.propertyphotofiles;

    // 🔥 1. Old data fetch karo (taake old images delete kiye jaa saken)
    const oldDoc = await getDoc(doc(firestored, "deals", id.toString()));
    const oldData = oldDoc.exists() ? oldDoc.data() : null;
    const oldImages = oldData?.propertyphoto || [];

    const selectedStage = data.step1.dealStage;

    const stageIndex = columnIds.indexOf(selectedStage);
    const allowedStages = columnIds.slice(0, stageIndex + 1);

    // 🔥 old tasks & tracker
    let existingTasks = oldData?.tasks || [];
    let existingTracker = oldData?.taskStatusTracker || {};
    let newTasks = [];
    let updatedTracker = { ...existingTracker };

    allowedStages.forEach((stage) => {
      // 👉 agar already exist karta hai → skip
      if (existingTracker[stage]) return;

      const stageTasks = Array.isArray(tasks?.[stage]) ? tasks[stage] : [];

      newTasks = [
        ...newTasks,
        ...stageTasks.map((t) => ({
          ...t,
          stage: stage,
          status: stage === selectedStage ? "Open" : "Completed",
          createdAt: new Date().toISOString(),
        })),
      ];

      // 👉 mark as added
      updatedTracker[stage] = true;
    });

    const finalTasks = [...existingTasks, ...newTasks];

    // -----------------------------
    // 🔥 2. Detect if new images are selected
    // -----------------------------
    let isNewImages =
      incomingFiles &&
      incomingFiles.length > 0 &&
      typeof incomingFiles[0] !== "string"; // if File type → new upload

    if (isNewImages) {
      // -----------------------------
      // 🔥 3. Upload Newly Selected Images
      // -----------------------------
      finalImageUrls = await uploadImagesToFirebase(incomingFiles);

      // -----------------------------
      // 🔥 4. Delete Old Firebase Images
      // -----------------------------
      for (let url of oldImages) {
        try {
          const fileRef = ref(storage, url);
          await deleteObject(fileRef);
        } catch (err) {
          console.log("Old image delete error:", err);
        }
      }
    } else {
      // -----------------------------
      // 🔥 5. Images NOT changed → keep old URLs as is
      // -----------------------------
      finalImageUrls = incomingFiles; // existing Firebase URLs
    }

    const wasApproved = editdata?.status === "Approved";

    let newdata = {
      status:
        user.role === "Admin" || user.role === "Supervisor"
          ? "Approved"
          : editdata.status,
      approvedby: user.id,
      dealtype: data.step2.clientType,
      propertyphoto: finalImageUrls,
      customers: data.step2.clientinfo,
      dealStage: data.step1.dealStage,
      financingType: data.step1.financingType,
      earnestMoney: data.step1.earnestMoney,
      inspection: data.step1.inspection,
      inspectionDeadline: data.step1.inspectionDeadline,
      financingDeadline: data.step1.financingDeadline,
      // mlsNumber: data.step1.mlsNumber,
      offerPrice: data.step1.offerPrice,
      propertyType: data.step1.propertyType,
      agentCommission: data.step3.agentCommission,
      fixedagentcommission: data.step3.fixedagentcommission,
      agentData: data.step3.agentid,
      agentName: data.step3.agentName,
      brokeradminfee: data.step3.brokeradminfee,
      captype: data.step3.captype,
      captypedescription: data.step3.captypedescription,
      closingdate: data.step1.closingdate,
      leadCommission: data.step3.leadCommission,
      leadsource: data.step3.leadsource,
      propertyaddress: data.step1.propertyaddress,
      splitdescription: data.step3.splitdescription,
      splittype: data.step3.splittype,
      inhousereferral: data.step3?.inhousereferral || false,
      teamleadName: data.step3.teamleadName,
      propertyLocation: data.step1.propertyLocation,
      flatfee: data.step4.flatfee,
      flatfeeamount: data.step4.flatfeeamount,
      assignedteamlead: data.step3.assignedteamlead,
      thirdpartyagentCommission: data.step3.thirdpartyagentCommission,
      thirdpartyagentName: data.step3.thirdpartyagentName,
      agentCommissionamount: data.step4.agentCommissionamount,
      bankcommission: data.step4.bankcommission,
      buyersidecommissionrate: data.step4.buyersidecommissionrate,
      leadsourceCommissionamount: data.step4.leadsourceCommissionamount,
      sellersidecommissionrate: data.step4.sellersidecommissionrate,
      takehomecommissionamount: data.step4.takehomecommissionamount,
      teamleadCommissionamount: data.step4.teamleadCommissionamount,
      teamleaddiscount: data.step4.teamleaddiscount,
      agentdiscount: data.step4.agentdiscount,
      teamleadcommissionrate: data.step4.teamleadcommissionrate,
      thirdpartyagentcommissionamount:
        data.step4.thirdpartyagentcommissionamount,
      totalCommissionamount: data.step4.totalCommissionamount,
      totalcommissionrate: data.step4.totalcommissionrate,
      tasks: finalTasks,
      taskStatusTracker: updatedTracker,
    };

    try {
      let result = await updateItem("deals", id, newdata);

      if (result === "success") {
        if (newTasks.length > 0) {
          newTasks.forEach((task) => {
            if (task?.assignee) {
              newmessagesuccess(
                "New Task Assigned",
                task.assignee?.id,
                task?.title || "",
                task.id || "",
                "newtask",
                newdata.createdat,
              );
            }
          });
        }

        toast.success("Deal updated successfully!");
        const updatedDeals = props.deals.map((item) =>
          item.createdat === id ? { ...item, ...newdata } : item,
        );

        console.log(updatedDeals);

        dispatch({
          type: actionType.STORE_DEALS,
          deals: updatedDeals,
        });
        setIsOpen(false);

        if (!wasApproved && newdata.status === "Approved") {
          try {
            await notifyAccountantsOnApproval(
              { ...newdata, createdat: id },
              users,
              user,
            );
          } catch (notifyErr) {
            console.error("Failed to notify accountants:", notifyErr);
          }
        }
      } else {
        toast.error(result || "Failed to update deal");
      }
    } catch (err) {
      toast.error(err.message);
    } finally {
    }
  };

  const filteredDeals = useMemo(() => {
    return props.deals.filter((deal) => {
      const text = search.toLowerCase();
      const agentNameString = (deal.agentName || "").toLowerCase();
      const dealteamlead = deal.assignedteamlead || "";
      const dealagent = deal.agentData || "";
      // 🔹 Search Filter
      const matchSearch =
        deal.propertyaddress?.toLowerCase().includes(text) ||
        deal.mlsNumber?.toLowerCase().includes(text) ||
        agentNameString.includes(text) ||
        (
          deal.customers?.map((c) => c.clientName?.toLowerCase()).join(" ") ||
          ""
        ).includes(text);

      // 🔹 DateRange Filter

      const closingtimestamp = new Date(
        deal?.closingdate + "T00:00:00Z",
      ).getTime();
      const DateRangeFilter =
        closingtimestamp >= startingdate.getTime() &&
        closingtimestamp <= endingdate.getTime();

      // 🔹 Status Filter
      const matchStatus =
        selectedStatus === "All Status" ||
        deal.dealStage?.toLowerCase() === selectedStatus.toLowerCase();

  // 🔹 Cap type Filter
     const matchcaptype =
        captype === "All" ||
        deal.captype?.toLowerCase() === captype.toLowerCase();
        


      // 🔹 Transaction Type Filter
      const matchTransaction =
        selectedTransaction === "All Types" ||
        deal.dealtype?.toLowerCase() === selectedTransaction.toLowerCase();

      // 🔹 Lead Source Filter
      const matchLead =
        selectedLead === "All Leads" ||
        deal.leadsource.abbreviation?.toLowerCase() ===
          selectedLead.toLowerCase();

      // 🔹 Agent Filter
      const matchAgent =
        selectedagent === "All Agents" ||
        dealteamlead === selectedagent ||
        dealagent === selectedagent;

      // 🔹 Date Range Filter (creationDate -> closingDate)
      const dealCreated = new Date(deal.createdat).setHours(0, 0, 0, 0);
      const dealClosing = new Date(deal.closingdate).setHours(0, 0, 0, 0);

      const startDate = creationDate
        ? new Date(creationDate).setHours(0, 0, 0, 0)
        : null;
      const endDate = closingDate
        ? new Date(closingDate).setHours(0, 0, 0, 0)
        : null;

      const matchDateRange =
        (!startDate || dealCreated === startDate) &&
        (!endDate || dealClosing === endDate);

      // 🔹 Active Filter
      let matchActiveFilter = true;

      if (activeFilter === "My Deals") {
        matchActiveFilter =
          user.role === "Admin" || user.role === "Supervisor"
            ? deal.createdby === user.id
            : deal.agentData === user.id;
      } else if (activeFilter === "Closing Soon") {
        const today = new Date();
        const oneMonthLater = new Date();
        oneMonthLater.setMonth(today.getMonth() + 1);

        const dealClosingDate = new Date(deal.closingdate);

        let employeeMatch = true;
        if (user.role === "Employee") {
          employeeMatch = deal.agentData === user.id;
        }

        matchActiveFilter =
          dealClosingDate >= today &&
          dealClosingDate <= oneMonthLater &&
          employeeMatch;
      } else if (activeFilter === "New This Week") {
        const today = new Date();
        const firstDayOfWeek = new Date(
          today.setDate(today.getDate() - today.getDay() + 1),
        ); // Monday
        const lastDayOfWeek = new Date(firstDayOfWeek);
        lastDayOfWeek.setDate(firstDayOfWeek.getDate() + 6); // Sunday

        const dealCreatedDate = new Date(deal.createdat);

        let employeeMatch = true;
        if (user.role === "Employee") {
          employeeMatch = deal.agentData === user.id;
        }

        matchActiveFilter =
          dealCreatedDate >= firstDayOfWeek &&
          dealCreatedDate <= lastDayOfWeek &&
          employeeMatch;
      }

      return (
        matchSearch &&
        matchStatus &&
        matchcaptype &&
        matchTransaction &&
        matchLead &&
        matchAgent &&
        matchDateRange &&
        matchActiveFilter &&
        DateRangeFilter
      );
    });
  }, [
    props.deals, // 🔥 state update
    search,
    selectedStatus,
    captype,
    selectedTransaction,
    selectedLead,
    selectedagent,
    creationDate,
    closingDate,
    activeFilter,
    user,
    startingdate,
    endingdate,
  ]);

  // const filteredDeals = props.deals.filter((deal) => {
  //   const text = search.toLowerCase();

  //   const agentNameString = (deal.agentName || "").toLowerCase();

  //   const matchSearch =
  //     deal.propertyaddress?.toLowerCase().includes(text) ||
  //     deal.mlsNumber?.toLowerCase().includes(text) ||
  //     agentNameString.includes(text) ||
  //     (
  //       deal.customers?.map((c) => c.clientName?.toLowerCase()).join(" ") || ""
  //     ).includes(text);

  //   const matchStatus =
  //     selectedStatus === "All Status" ||
  //     deal.dealStage?.toLowerCase() === selectedStatus.toLowerCase();

  //   const matchTransaction =
  //     selectedTransaction === "All Types" ||
  //     deal.dealtype?.toLowerCase() === selectedTransaction.toLowerCase();

  //   const matchLead =
  //     selectedLead === "All Leads" ||
  //     deal.leadsource.abbreviation?.toLowerCase() ===
  //       selectedLead.toLowerCase();

  //   const matchAgent =
  //     selectedagent === "All Agents" ||
  //     agentNameString === selectedagent.toLowerCase();

  //   // 🔥 Date Range Filter (creationDate start -> closingDate end)
  //   // 🔥 Date Filter: only deals on selected creationDate and closingDate
  //   const dealCreated = new Date(deal.createdat).setHours(0, 0, 0, 0);
  //   const dealClosing = new Date(deal.closingdate).setHours(0, 0, 0, 0);

  //   const startDate = creationDate
  //     ? new Date(creationDate).setHours(0, 0, 0, 0)
  //     : null;
  //   const endDate = closingDate
  //     ? new Date(closingDate).setHours(0, 0, 0, 0)
  //     : null;

  //   // ✅ Only match deals exactly on creationDate and closingDate
  //   const matchDateRange =
  //     (!startDate || dealCreated === startDate) &&
  //     (!endDate || dealClosing === endDate);

  //   let matchActiveFilter = true;
  //   if (activeFilter === "My Deals") {
  //     if (user.role === "Admin") {
  //       // Admin → check createdby
  //       matchActiveFilter = deal.createdby === user.id;
  //     } else {
  //       // Employee → check agentid
  //       matchActiveFilter = deal.agentData === user.id;
  //     }
  //   } else if (activeFilter === "Closing Soon") {
  //     const today = new Date();
  //     const oneMonthLater = new Date();
  //     oneMonthLater.setMonth(today.getMonth() + 1);

  //     const dealClosingDate = new Date(deal.closingdate);

  //     matchActiveFilter =
  //       dealClosingDate >= today && dealClosingDate <= oneMonthLater;
  //   } else if (activeFilter === "New This Week") {
  //     const today = new Date();
  //     const firstDayOfWeek = new Date(
  //       today.setDate(today.getDate() - today.getDay() + 1)
  //     ); // Monday
  //     const lastDayOfWeek = new Date(firstDayOfWeek);
  //     lastDayOfWeek.setDate(firstDayOfWeek.getDate() + 6); // Sunday

  //     const dealCreatedDate = new Date(deal.createdat);

  //     matchActiveFilter =
  //       dealCreatedDate >= firstDayOfWeek && dealCreatedDate <= lastDayOfWeek;
  //   }

  //   return (
  //     matchSearch &&
  //     matchStatus &&
  //     matchTransaction &&
  //     matchLead &&
  //     matchAgent &&
  //     matchDateRange &&
  //     matchActiveFilter
  //   );
  // });

  const currentYear = new Date().getFullYear();
  // const currentYear = 2025;
  // 🔹 Filter deals based on logged-in user
  const userDeals = props.deals.filter((deal) => {
    if (
      user.role === "Admin" ||
      user.role === "Supervisor" ||
      user.role == "Accountant"
    ) {
      return true; // Admin sees all deals
    } else {
      // Employee sees only their deals
      return deal.agentData === user.id || deal.createdby === user.id;
    }
  });

  // 🔹 Under Contract Count
  const underContractCount = userDeals.filter((deal) => {
    if (!deal?.createdat) return false;

    const dealYear = new Date(Number(deal.createdat)).getFullYear();

    return deal.dealStage === "Under Contract" && dealYear === currentYear;
  }).length;

  // 🔹 Pending Count
  const pendingCount = userDeals.filter((deal) => {
    if (!deal?.createdat) return false;

    const closingYear = new Date(Number(deal.createdat)).getFullYear();

    return deal.dealStage === "Pending" && closingYear === currentYear;
  }).length;

  // 🔹 Closed Deals
  const closedDeals = userDeals.filter(
    (deal) =>
      deal?.dealStage === "Closed" &&
      new Date(deal?.closingdate).getFullYear() === currentYear,
  );

  const leadSourceData = leadsource.map((source) => {
    const matchedDeals = closedDeals.filter(
      (deal) => deal?.leadsource.abbreviation === source?.abbreviation,
    );

    return {
      leadsourceId: source?.id,
      leadsourceAbbreviation: source?.abbreviation,
      dealClosedCount: matchedDeals.length,
      deals: matchedDeals,
    };
  });

  // 🔹 Closed Deals
  const pendingDeals = userDeals.filter(
    (deal) =>
      deal.dealStage.toLowerCase() != "closed" &&
      deal.dealStage.toLowerCase() != "cancelled" &&
      deal.dealStage.toLowerCase() != "expired" &&
      new Date(deal?.closingdate).getFullYear() === currentYear,
  );

  // 🔹 Total Pending Offer Price
  const totalPendingOfferPrice = pendingDeals.reduce(
    (sum, deal) => sum + Number(deal?.offerPrice || 0),
    0,
  );

  // 🔹 Total Closed Offer Price
  const totalOfferPrice = closedDeals.reduce(
    (sum, deal) => sum + Number(deal?.offerPrice || 0),
    0,
  );

  // 🔹 Net Closed and pending Offer Price
  const OfferPrice = totalOfferPrice + totalPendingOfferPrice;

  const totalCommission = closedDeals.reduce((sum, deal) => {
    const amount =
      user.role === "Admin" ||
      user.role === "Supervisor" ||
      user.role == "Accountant"
        ? Number(deal?.takehomecommissionamount || 0)
        : Number(deal?.agentCommissionamount || 0); // ✅ Use agentCommissionamount for employee
    return sum + amount;
  }, 0);

  // 🔹 Filtered Deals for other statuses (excluding Closed, Cancelled, Expired)
  const filteredStatus = userDeals.filter((deal) => {
    if (!deal?.createdat) return false;

    const dealYear = new Date(Number(deal.createdat)).getFullYear();

    return (
      !["Closed", "Cancelled", "Expired"].includes(deal?.dealStage) &&
      dealYear === currentYear
    );
  });

  // 🔹 Sum commission for filteredStatus based on role
  const totalTakeHomeCommission = filteredStatus.reduce((sum, deal) => {
    const amount =
      user.role === "Admin" ||
      user.role === "Supervisor" ||
      user.role == "Accountant"
        ? Number(deal?.takehomecommissionamount || 0)
        : Number(deal?.agentCommissionamount || 0); // ✅ Use agentCommissionamount for employee
    return sum + amount;
  }, 0);

  const clearFilters = () => {
    setSearch("");

    // 🔹 For employees, default filter should be "My Deals"
    if (user.role === "Employee") {
      setActiveFilter("My Deals");
    } else {
      setActiveFilter("All"); // Admins can see all
    }

    setSelectedStatus("All Status");
    setcaptype("All")
    setSelectedTransaction("All Types");
    setSelectedLead("All Leads");
    setSelectedagent("All Agents");
    setCreationDate(null);
    setClosingDate(null);
    setstartingdate(new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0));
    setendingdate(new Date(new Date().getFullYear(), 11, 31, 23, 59, 59, 999));
  };

  const handleOnEdit = (data) => {
    seteditdata(data);
    setIsOpen(true);
  };

  const handleDelete = (data) => {
    seteditdata(data);
    setIsDelete(true);
  };

  const handleOnApprove = (data) => {
    seteditdata(data);
    setIsOpen(true);
  };

  async function getalldeal() {
    await getAlldealforAdmin("deals")
      .then(async (response) => {
        dispatch({
          type: actionType.STORE_DEALS,
          deals: response,
        });
      })
      .catch((err) => {
        alert(err);
      });
  }

  useEffect(() => {
    console.log("🔥 props.deals updated", props.deals);
  }, [props.deals]);

  // Auto-open the approval modal when arriving with ?approve=<createdat>.
  // PendingInboxPanel on the dashboard links here with that param so admins
  // get the popup in one click instead of having to navigate + click Edit.
  useEffect(() => {
    const approveId = searchParams.get("approve");
    if (!approveId) return;
    const deal = (props.deals || []).find(
      (d) => String(d?.createdat) === String(approveId),
    );
    if (deal) {
      handleOnApprove(deal);
      // Clear the param so refreshing or navigating doesn't re-pop the modal.
      const next = new URLSearchParams(searchParams);
      next.delete("approve");
      setSearchParams(next, { replace: true });
    }
    // We want this to fire when the deals list arrives or the URL changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams, props.deals]);

  const capitalizeFirst = (str) => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
};
  useEffect(() => {
    const fetchData = async () => {
      const data = await getTaskTemplate();
      setTasks(data || {});
      console.log("task templates", data);
    };

    fetchData();
  }, []);

  // Shared "open stat popup" helper so each card stays a one-liner.
  const openStat = (label, filterFn) => {
    setstatspopup(true);
    setselectedstat(label);
    setstatsdata(userDeals.filter(filterFn));
  };

  // Common deal-closing-year predicate.
  const inCurrentYear = (deal) => {
    if (!deal?.closingdate) return false;
    return new Date(deal.closingdate).getFullYear() === currentYear;
  };

  return (
    <div>
      <section className="grid gap-3 grid-cols-2 lg:grid-cols-4 mb-5">
        {((user.role === "Supervisor" && user.access?.underContract) ||
          user.role === "Admin" ||
          user.role == "Accountant") && (
          <StatCard
            icon={FileText}
            accent="amber"
            label="Under Contract"
            value={underContractCount}
            onClick={() =>
              openStat(
                "Deals - Under Contract",
                (deal) =>
                  inCurrentYear(deal) && deal.dealStage === "Under Contract",
              )
            }
          />
        )}
        {((user.role === "Supervisor" && user.access?.pending) ||
          user.role === "Admin" ||
          user.role === "Employee" ||
          user.role == "Accountant") && (
          <StatCard
            icon={Clock}
            accent="indigo"
            label="Pending"
            value={pendingCount}
            onClick={() =>
              openStat(
                "Deals - Pending",
                (deal) => inCurrentYear(deal) && deal.dealStage === "Pending",
              )
            }
          />
        )}
        {((user.role === "Supervisor" && user.access?.closed) ||
          user.role === "Admin" ||
          user.role == "Accountant" ||
          user.role === "Employee") && (
          <StatCard
            icon={CheckCircle2}
            accent="emerald"
            label="Closed"
            value={closedDeals.length}
            onClick={() =>
              openStat(
                "Deals - Closed",
                (deal) => inCurrentYear(deal) && deal.dealStage === "Closed",
              )
            }
          />
        )}

        {(user.role === "Admin" ||
          user.role == "Accountant" ||
          user.role === "Employee") && (
          <StatCard
            icon={Hourglass}
            accent="sky"
            label="Pending Volume"
            value={`$${formatNumberShort(totalPendingOfferPrice)}`}
            title={formatCurrency(totalPendingOfferPrice)}
            onClick={() =>
              openStat("Deals - Pending Volume", (deal) => {
                const stage = (deal.dealStage || "").toLowerCase();
                return (
                  inCurrentYear(deal) &&
                  stage !== "closed" &&
                  stage !== "cancelled" &&
                  stage !== "expired"
                );
              })
            }
          />
        )}
        {(user.role === "Admin" ||
          user.role == "Accountant" ||
          user.role === "Employee") && (
          <StatCard
            icon={Wallet}
            accent="emerald"
            label="Closed Volume"
            value={`$${formatNumberShort(totalOfferPrice)}`}
            title={formatCurrency(totalOfferPrice)}
            onClick={() =>
              openStat(
                "Deals - Closed Volume",
                (deal) => inCurrentYear(deal) && deal.dealStage === "Closed",
              )
            }
          />
        )}

        {(user.role === "Admin" ||
          user.role == "Accountant" ||
          user.role === "Employee") && (
          <StatCard
            icon={TrendingUp}
            accent="emerald"
            label="Net Volume"
            value={`$${formatNumberShort(OfferPrice)}`}
            title={formatCurrency(OfferPrice)}
            onClick={() => openStat("Deals - Net Volume", inCurrentYear)}
          />
        )}

        {(user.role === "Admin" ||
          user.role == "Accountant" ||
          user.role === "Employee") && (
          <StatCard
            icon={Coins}
            accent="amber"
            label="Commission Volume"
            value={`$${formatNumberShort(totalCommission)}`}
            title={formatCurrency(totalCommission)}
            onClick={() =>
              openStat(
                "Deals - Closed Commission Volume",
                (deal) => inCurrentYear(deal) && deal.dealStage === "Closed",
              )
            }
          />
        )}
        {(user.role === "Admin" ||
          user.role == "Accountant" ||
          user.role === "Employee") && (
          <StatCard
            icon={PiggyBank}
            accent="violet"
            label="Pending Commission"
            value={`$${formatNumberShort(totalTakeHomeCommission)}`}
            title={formatCurrency(totalTakeHomeCommission)}
            onClick={() =>
              openStat("Deals - Pending Commission Volume", (deal) => {
                const stage = (deal.dealStage || "").toLowerCase();
                return (
                  inCurrentYear(deal) &&
                  stage !== "closed" &&
                  stage !== "cancelled" &&
                  stage !== "expired"
                );
              })
            }
          />
        )}
      </section>

      <div className="mb-4">
        <ImportantDatesWidget />
      </div>

      <div className="bg-white px-4 py-3 rounded-lg border border-slate-200 w-full mb-4">
        <h3 className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-3">
          Lead Source — Closed Transactions
        </h3>

        <div className="flex gap-2 flex-wrap">
          {leadSourceData
            .filter((item) => item.dealClosedCount > 0)
            .sort((a, b) => b.dealClosedCount - a.dealClosedCount)
            .map((item) => (
              <button
                type="button"
                key={item.leadsourceId}
                onClick={() => {
                  setstatspopup(true);
                  setselectedstat("Deals - Lead Source");
                  setstatsdata(item.deals);
                }}
                className="flex items-center gap-2 bg-slate-50 hover:bg-slate-100 border border-slate-200 rounded-md px-3 py-1.5 text-sm transition"
              >
                <span className="font-medium text-slate-700 truncate max-w-[10rem]">
                  {item.leadsourceAbbreviation}
                </span>
                <span className="text-slate-900 font-bold">
                  {item.dealClosedCount}
                </span>
              </button>
            ))}
        </div>
      </div>
      <div className="bg-white rounded-lg border border-slate-200 p-4 mb-3">
        {/* Search Bar */}
        <div className="flex gap-2 mb-2">
          <div className="relative flex-1">
            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 text-xs">
              🔍
            </span>
            <input
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search by address, client name, or agent…"
              className="w-full pl-9 pr-3 py-2 border border-slate-200 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 text-sm"
            />
          </div>
          <button className="px-4 py-2 bg-slate-900 hover:bg-slate-800 text-white text-sm font-semibold rounded-md transition">
            Search
          </button>
        </div>

        {/* Filter Section */}
        <div className="border-t border-slate-200 pt-2">
          <div className="flex items-center flex-wrap gap-2 mb-3">
            <span className="text-xs font-semibold uppercase tracking-wider text-slate-500 mr-1">
              Quick:
            </span>
            {filters.map((item) => (
              <button
                key={item}
                onClick={() => setActiveFilter(item)}
                className={`px-3 py-1.5 rounded-full text-sm font-medium border transition ${
                  activeFilter === item
                    ? "bg-slate-900 text-white border-slate-900"
                    : "bg-white text-slate-600 border-slate-200 hover:border-slate-900 hover:text-slate-900"
                }`}
              >
                {item}
              </button>
            ))}
          </div>
          <div className="flex flex-col lg:flex-row gap-y-2 lg:gap-y-0 lg:gap-x-2 lg:items-end">
            <div className="w-full flex relative flex-col">
              <label className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-1 whitespace-nowrap">Status</label>

              <div
                onClick={() => setteamleadpopup(!teamleadpopup)}
                className={`w-full border border-slate-300 text-sm ${
                  selectedStatus === "" ? "text-gray-400" : "text-textcolor"
                } rounded-md px-3 py-2 cursor-pointer`}
              >
                {selectedStatus}
              </div>

              {/* Dropdown Component */}
              <StatusFilter
                style={{ top: "70px" }}
                visible={teamleadpopup}
                activateoutsidecontainerclick={() => setteamleadpopup(false)}
                onClickcorrect={(value) => {
                  setSelectedStatus(value);
                  setteamleadpopup(false);
                }}
              />
            </div>
                 <div className="w-full flex relative flex-col">
              <label className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-1 whitespace-nowrap">Cap Type</label>

              <div
                onClick={() => setcaptypepopup(!captypepopup)}
                className={`w-full border border-slate-300 text-sm ${
                  captype === "" ? "text-gray-400" : "text-textcolor"
                } rounded-md px-3 py-2 cursor-pointer`}
              >
                {capitalizeFirst(captype)}
              </div>

              {/* Dropdown Component */}
              <CapTypePopUp
                style={{ top: "70px" }}
                visible={captypepopup}
                activateoutsidecontainerclick={() => setcaptypepopup(false)}
                onClickcorrect={(item) => {
                  setcaptype(item.value);
                  setcaptypepopup(false);
                }}
              
              />
            </div>
            <div className="w-full flex relative flex-col">
              <label className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-1 whitespace-nowrap">Transaction Type</label>

              <div
                onClick={() => settransactionpopup(!transactionpopup)}
                className={`w-full border border-slate-300 text-sm ${
                  selectedTransaction === ""
                    ? "text-gray-400"
                    : "text-textcolor"
                } rounded-md px-3 py-2 cursor-pointer`}
              >
                {selectedTransaction}
              </div>

              {/* Dropdown Component */}
              <TransactionFilter
                style={{ top: "70px" }}
                visible={transactionpopup}
                activateoutsidecontainerclick={() => settransactionpopup(false)}
                onClickcorrect={(value) => {
                  setSelectedTransaction(value);
                  settransactionpopup(false);
                }}
              />
            </div>
            <div className="w-full flex relative flex-col">
              <label className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-1 whitespace-nowrap">Lead Source</label>

              <div
                onClick={() => setleadpopup(!leadpopup)}
                className={`w-full border border-slate-300 text-sm ${
                  selectedLead === "" ? "text-gray-400" : "text-textcolor"
                } rounded-md px-3 py-2 cursor-pointer`}
              >
                {selectedLead}
              </div>

              {/* Dropdown Component */}
              <LeadSourcePopup
                style={{ top: "70px" }}
                visible={leadpopup}
                data={[{ abbreviation: "All Leads" }, ...leadsource]}
                activateoutsidecontainerclick={() => setleadpopup(false)}
                onClickcorrect={(value) => {
                  setSelectedLead(value.abbreviation);
                  setleadpopup(false);
                }}
              />
            </div>
            <div className="w-full flex relative flex-col">
              <label className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-1 whitespace-nowrap">Agent</label>

              <div
                onClick={() => setagentpopup(!agentpopup)}
                className={`w-full border border-slate-300 text-sm ${
                  agentname === "" ? "text-gray-400" : "text-textcolor"
                } rounded-md px-3 py-2 cursor-pointer`}
              >
                {agentname || "All Agents"}
              </div>

              <AgentPopUp
                style={{ top: "70px" }}
                visible={agentpopup}
                data={employees.filter(
                  (emp) => emp.type !== 1 && emp.type !== 2,
                )}
                activateoutsidecontainerclick={() => setagentpopup(false)}
                onClickcorrect={(value, name) => {
                  setSelectedagent(value);
                  setagentname(name);
                  setagentpopup(false);
                }}
              />
            </div>
            {/* <div className="flex flex-col">
              <label className="text-sm font-medium">Creation Date</label>
              <input
                type="date"
                value={creationDate || ""}
                onChange={(e) => setCreationDate(e.target.value)}
                className="border-2 border-gray-300 rounded-lg p-2"
              />
            </div>


            <div className="flex flex-col">
              <label className="text-sm font-medium">Closing Date</label>
              <input
                type="date"
                value={closingDate || ""}
                onChange={(e) => setClosingDate(e.target.value)}
                className="border-2 border-gray-300 rounded-lg p-2"
              />
            </div> */}
            <div className="flex w-full flex-col">
              <label className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-1 whitespace-nowrap">From</label>

              <DatePicker
                className="border w-full border-slate-300 rounded-md px-3 py-2 text-sm"
                selected={startingdate}
                onChange={(date) => {
                  setstartingdate(new Date(date.setHours(0, 0, 0, 0)));
                }}
              />
            </div>
            <div className="flex w-full flex-col">
              <label className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-1 whitespace-nowrap">To</label>

              <DatePicker
                className="border w-full border-slate-300 rounded-md px-3 py-2 text-sm"
                selected={endingdate}
                onChange={(date) => {
                  setendingdate(new Date(date.setHours(23, 59, 59, 59)));
                }}
              />
            </div>
          </div>

          <div className="mt-3">
            <button
              onClick={clearFilters}
              className="px-4 py-2 border border-red-500 text-red-600 hover:bg-red-50 flex gap-1.5 items-center text-sm font-semibold rounded-md transition"
            >
              <FunnelX size={16} />
              Clear Filters
            </button>
          </div>
        </div>
      </div>

      {/* Results Header */}
      <div className="flex items-center justify-between gap-2 mb-3">
        <p className="text-sm text-slate-600">
          Found{" "}
          <strong className="text-slate-900 font-semibold">
            {filteredDeals.length}
          </strong>{" "}
          transactions
        </p>
      </div>

      {/* Transactions Grid */}

      <div className="grid gap-2">
        {filteredDeals.map((item, i) => (
          <>
            <DealCard
              data={item}
              isShowApprove={true}
              isShowEdit={true}
              isShowDelete={true}
              onEdit={(dealData) => handleOnEdit(dealData)}
              onDelete={(daealData) => handleDelete(daealData)}
              onAprove={(dealData) => handleOnApprove(dealData)}
            />
          </>
        ))}
      </div>

      {isOpen && (
        <AddNewDeal
          onClose={() => setIsOpen(false)}
          isedit={true}
          editdata={editdata}
          onSubmit={(data, bool, id) => {
            updatedeal(data, bool, id);
          }}
          steps={steps}
        />
      )}

      {statspopup && (
        <StatDetails
          // isLoading={isLoading}

          Data={statsdata}
          selectedstat={selectedstat}
          onClose={() => setstatspopup(false)}
          onSubmit={(data) => {
            alert(data);
          }}
        />
      )}
      {isDelete && (
        <DeleteDeal
          deal={editdata}
          onClose={() => setIsDelete(false)}
          onSubmit={getalldeal}
        />
      )}
    </div>
  );
}

function StatCard({ icon: Icon, label, value, title, onClick, accent = "slate" }) {
  // Compact, flat stat card. Accent controls the icon swatch color.
  const accentClasses = {
    indigo: "bg-indigo-50 text-indigo-600",
    amber: "bg-amber-50 text-amber-600",
    emerald: "bg-emerald-50 text-emerald-600",
    rose: "bg-rose-50 text-rose-600",
    sky: "bg-sky-50 text-sky-600",
    violet: "bg-violet-50 text-violet-600",
    slate: "bg-slate-100 text-slate-600",
  };
  return (
    <button
      type="button"
      onClick={onClick}
      title={title}
      className="text-left bg-white border border-slate-200 rounded-lg px-4 py-3 hover:border-slate-300 hover:shadow-sm transition flex items-center gap-3 cursor-pointer"
    >
      <div
        className={`size-9 rounded-md flex items-center justify-center flex-shrink-0 ${accentClasses[accent] || accentClasses.slate}`}
      >
        {Icon && <Icon size={16} />}
      </div>
      <div className="min-w-0">
        <div className="text-[11px] uppercase tracking-wider text-slate-500 font-semibold truncate">
          {label}
        </div>
        <div className="text-xl font-bold text-slate-900 truncate">{value}</div>
      </div>
    </button>
  );
}
